<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
    <v-container>
        <v-row>
            <v-col cols="8">
        <v-breadcrumbs :items="breadcrumbs">
            <template v-slot:item="{ item }">
                <v-breadcrumbs-item :href="item.href">
                  <template v-if="item.href">
                    <router-link class="text-decoration-none" :to="item.href">
                      {{ item.text }}
                    </router-link>
                  </template>
                  <template v-else>
                    {{ item.text }}
                  </template>
<!--                  <router-link :to="item.href">-->
<!--                    {{ item.text }}-->
<!--                  </router-link>-->
                </v-breadcrumbs-item>
            </template>
        </v-breadcrumbs>
        </v-col>
        <v-col cols="4">
            <v-container>
        <div class="d-flex justify-end">
            {{ getTodayDate() }}
        </div>
        </v-container>
        </v-col>
        </v-row>
    </v-container>
</template>

<script>
export default {
    props:{
        breadcrumbs: Array
    },
    methods:{
        getTodayDate(){
                var todayDate = ''
                var days = ["Nedjelja","Ponedjeljak","Utorak","Srijeda","Četvrtak","Petak","Subota"]
                var dd = new Date

                todayDate += days[dd.getDay()] + ', ' + dd.getDate() + '.' + (dd.getMonth() + 1) + '.' + dd.getFullYear()
                
                return todayDate
            },
        }
}
</script>

<style>

</style>